/**
 * Benchmark Line Component
 *
 * Renders the benchmark comparison line on the chart.
 */

import { CHART_COLORS } from "../constants";
import { indexToX, valueToY, generateSmoothPath } from "../utils";
import type { PerformanceDataPoint } from "../types";

interface BenchmarkLineProps {
  data: PerformanceDataPoint[];
  min: number;
  max: number;
}

/**
 * Benchmark comparison line
 */
export function BenchmarkLine({ data, min, max }: BenchmarkLineProps) {
  if (data.length === 0) return null;

  const points = data.map((point, index) => ({
    x: indexToX(index, data.length),
    y: valueToY(point.benchmarkValue, min, max),
  }));

  const linePath = generateSmoothPath(points);

  return (
    <g className="benchmark-line">
      <path
        d={linePath}
        fill="none"
        stroke={CHART_COLORS.benchmark.stroke}
        strokeWidth={1.5}
        strokeDasharray={CHART_COLORS.benchmark.strokeDash}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity={0.6}
      />
    </g>
  );
}
